import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ThankYou = ({ formData, variant }) => {
  return (
    <StyledDiv
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.25 }}
    >
      <h2>Thank you for your design request!</h2>
      <h4>
        Our design process takes between 3-5 business days. As soon as your
        designs are finished, your lead designer will be in contact with you via
        email and phone. Please contact us if you need anything else in the
        meantime.
      </h4>

      {variant !== 'boa' && (
        <>
          {formData.sport === 'apparel' ? (
            <>
              <h4>Does Your team need custom uniforms?</h4>
          <a
            href="https://www.teamtriton.com/freedesigns.html"
            target="_blank"
            rel="noreferrer"
          >
            Click Here to request your free custom uniform designs {'>'}
          </a>
        </>
      ) : (
        <>
          <h4>Does Your team need custom apparel?</h4>
          <a
            href="https://www.teamtriton.com/apparel-designs.html"
            target="_blank"
            rel="noreferrer"
          >
            Click Here to request your free custom apparel designs {'>'}
          </a>
        </>
      )}
      </>
      )}
    </StyledDiv>
  );
};

const StyledDiv = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 25px;

  h2 {
    font-size: 2.5rem;
    text-align: center;
  }

  h4 {
    font-size: 1.5rem;
    text-align: center;
  }

  a {
    background-color: var(--red);
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    text-decoration: none;
  }
`;

export default ThankYou;
